(function () {
    function hidePreloader() {
        const preloader = document.getElementById('tg-preloader');

        if (!preloader) return;

        preloader.classList.add('hide');

        setTimeout(function () {
            preloader.remove();
        }, 500);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', hidePreloader);
    } else {
        hidePreloader();
    }

    // Absolute safety fallback
    setTimeout(hidePreloader, 1800);
})();